import loadingAnimation from "assets/animations/loading.json";
import Lottie from "lottie-react";
import React from "react";
import { Container } from "./styles";

const PageLoader: React.FC = () => {
  return (
    <Container>
      <Lottie
        animationData={loadingAnimation}
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        className="loader-animation"
      />
    </Container>
  );
};

export default PageLoader;
